import firebase from "firebase/app";

import { Card } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import organizationTypes from "astrid-firestore/src/api/organizations/constants/organizationTypes";
import updateOrganization from "astrid-firestore/src/api/organizations/updateOrganization";
import { currencyOptions } from "astrid-hooks/src/useCurrencyOptions";

import Form from "../../../../forms/components/Form/Form";
import useSimpleForm from "../../../../forms/hooks/useSimpleForm";
import CurrencySelect from "../../../../prices/components/CurrencySelect/CurrencySelect";
import PrimaryButton from "../../../../ui/components/Buttons/PrimaryButton";

export default function OrganizationFinanceSettings({ organization }) {
	const { t } = useTranslation();

	const form = useSimpleForm({
		defaultValues: {
			financeEmail: organization.financeEmail || "",
			currencyOptions: organization.currencyOptions || [],
			currencyDefault: organization.currencyDefault || null,
			scheduledOrdersDate: organization.finance?.scheduledOrdersDate || 25,
			invoiceFooter: organization.invoiceFooter || "",
		},
		onSubmit: ({ financeEmail, currencyOptions, currencyDefault, scheduledOrdersDate, invoiceFooter }) => {
			return updateOrganization(firebase, organization.ref, {
				financeEmail,
				currencyOptions,
				currencyDefault,
				"finance.scheduledOrdersDate": scheduledOrdersDate,
				invoiceFooter,
			});
		},
	});

	const { formState, onSubmit } = form;

	const currencyOptions = form.watch("currencyOptions");

	return (
		<Card fluid>
			<Card.Content>
				<Form form={form} style={{ width: "100%" }}>
					<Form.Group widths="equal">
						{organization.type === organizationTypes.PRODUCER && (
							<Form.Input name="financeEmail" label={t("financeEmail", "Finance email")} />
						)}

						<Form.Field
							name="currencyOptions"
							label={t("selectableCurrencies", "Selectable currencies")}
							rules={{ required: false }}
						>
							<CurrencySelect search multiple />
						</Form.Field>
					</Form.Group>

					<Form.Group widths="equal">
						<Form.Field
							name="currencyDefault"
							label={t("currencyDefault", "Default currency")}
							rules={{ required: false }}
						>
							<CurrencySelect search limitedOptions={currencyOptions} />
						</Form.Field>

						<Form.NumberInput
							name="scheduledOrdersDate"
							label={t("scheduledPurchaseOrdersDayInMonth")}
							rules={{ required: false }}
						/>
					</Form.Group>

					<Form.TextArea
						name="invoiceFooter"
						rows={6}
						label={t("invoiceFooter", "Invoice footer")}
						rules={{ required: false }}
					/>
				</Form>
			</Card.Content>

			<Card.Content>
				<PrimaryButton
					disabled={formState.isSubmitting || !formState.isDirty}
					loading={formState.isSubmitting}
					onClick={onSubmit}
				>
					{t("save", "Save")}
				</PrimaryButton>
			</Card.Content>
		</Card>
	);
}
